<div
  class="flex flex-col justify-between group cursor-pointer transition-all duration-200"
  [ngClass]="{ 'h-4 mb-3': collapse(), 'h-6': !collapse() }"
  (click)="toggle()"
>
  <span
    class="border-b-4 rounded-full transition-all duration-200 border-b-primary-900 w-8"
    [ngClass]="{
      'rotate-45': collapse(),
      'group-hover:rotate-12': !collapse(),
      'w-[19px]': collapse()
    }"
  ></span>
  <span
    class="border-b-4 rounded-full border-b-primary-900 transition-all duration-200"
    [ngClass]="{ 'w-0': collapse(), 'w-8': !collapse() }"
  ></span>
  <span
    class="border-b-4 rounded-full border-b-primary-900 w-8 transition-all duration-200"
    [ngClass]="{ '-rotate-45': collapse(), 'w-[19px]': collapse() }"
  ></span>
</div>
